/** Top bar: breadcrumb + title, source-health chips, theme toggle, lock. */
import { useHealth } from '../lib/hooks';
import { TITLES } from '../lib/nav';
import type { Theme } from '../lib/hooks';
import { Chip, Dot, SourceChip } from '../ui';

export default function Topbar({
  view,
  theme,
  onToggleTheme,
  onLock,
}: {
  view: string;
  theme: Theme;
  onToggleTheme: () => void;
  onLock: () => void;
}) {
  const [group, label] = TITLES[view] ?? ['', ''];
  const { data: health } = useHealth();
  const ok = health?.status === 'ok';
  const sources = health?.sources ?? [];

  return (
    <div className="flex items-center gap-3.5 border-b border-line bg-panel px-5 py-2.5">
      <div>
        <div className="text-[12px] text-faint">{group}</div>
        <h1 className="text-[15px] font-semibold">{label}</h1>
      </div>
      <div className="ml-auto flex items-center gap-2">
        {!health && <Chip><Dot kind="muted" />connecting…</Chip>}
        {sources.map((s) => (
          <SourceChip key={s} source={s} />
        ))}
        {health && (
          <Chip className={ok ? undefined : 'border-bad text-bad'}>
            <Dot kind={health.db === 'ok' ? 'ok' : 'bad'} />
            DB
          </Chip>
        )}
        <button className="btn btn-sm" onClick={onToggleTheme} title="Toggle light / dark" aria-label="Toggle theme">
          {theme === 'dark' ? '☾' : '☀'}
        </button>
        <button className="btn btn-sm" onClick={onLock} title="Forget the key and lock the console">
          Lock 🔒
        </button>
      </div>
    </div>
  );
}
